import { render } from "./Summary.vue?vue&type=template&id=3667729f"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"
script.render = render

export default script